<template>

    <div class="bg-secondary py-5">

        <inertia-head title="Reset Password">
        </inertia-head>

        <div class="container">
            <div class="row justify-content-center">
                <div class="col" style="max-width: 360px;">
                    <div class="card rounded-3 shadow border-0">
                        <div class="card-header border-0">{{ __('Reset Password') }}</div>

                        <div class="card-body">

                            <div class="alert alert-success" role="alert" v-if="status">
                                {{ status }}
                            </div>

                            <form @submit.prevent="form.post(route('password.email'))">
                                <text-input type="email" :floating="true" label="email" v-model="form.email" :error="form.errors.email" autocomplete="email" autofocus />
                                <submit-button :label="__('Send Password Reset Link')" child-class="w-100" />
                            </form>     

                            <div v-if="route().has('login')">
                                <hr />
                                <inertia-link :href="route('login')">
                                    {{ __('Zum Login') }}
                                </inertia-link>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>

</template>

<script>

    import SlimLayout from '@/shared/Layouts/SlimLayout';

    import TextInput from '@/shared/Inputs/TextInput';
    import CheckboxInput from '@/shared/Inputs/CheckboxInput';
    import SubmitButton from '@/shared/Inputs/SubmitButton';

    export default {
        layout: SlimLayout,
        props: [
            'status'
        ],
        data() {
            return {
                form: this.$inertia.form({
                    email: null,
                }),
            }
        },
        components: {
            TextInput,
            CheckboxInput,
            SubmitButton,
        },
        computed: {
        },
    }
</script>
